import { useCallback } from 'react'
import type { LatLngExpression } from 'leaflet'
import useParam from '../../../shared/hooks/useParam'
import { centerParam, zoomParam } from '../query-params'
import type {
  ZoomHandler,
  MoveHandler,
} from '../../../shared/components/LeafletMap/hooks/useEvents'
import {
  DEFAULT_MAP_OPTIONS,
  MAP_DEFAULT_CENTER,
} from '../../../shared/components/LeafletMap/LeafletMap'

const useMapPosition = (): [
  center: LatLngExpression,
  handleMove: MoveHandler,
  zoom: number,
  handleZoom: ZoomHandler,
] => {
  const [center, setCenter] = useParam(centerParam)
  const handleMove: MoveHandler = useCallback((newCenter) => {
    setCenter(newCenter, 'replace')
  }, [])

  const [zoom, setZoom] = useParam(zoomParam)
  const handleZoom: ZoomHandler = useCallback((newZoom) => {
    setZoom(newZoom, 'replace')
  }, [])

  return [center ?? MAP_DEFAULT_CENTER, handleMove, zoom ?? DEFAULT_MAP_OPTIONS.zoom, handleZoom]
}

export default useMapPosition
